import { useQuery } from '@apollo/client';
import { IPromotion } from 'common/promotion';
import { TripType } from 'contexts/searchParams';
import GET_PROMOTIONS from './internationalPromotions.gql';

interface IData {
  promotions: IPromotion[];
}

export default function useInternationalPromotions(
  fareType: string,
  trip: TripType,
) {
  const { data } = useQuery<IData>(GET_PROMOTIONS, {
    variables: { fareType, trip },
  });
  return data?.promotions || [];
}
